module.exports = __webpack_public_path__ + "img/王斌杜卓童.5a84c8d0.jpg";